import { Component, OnChanges, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ActivityResult, Encounter } from '../data/student-report';
import { GeneratedArtifactMeta } from '../data/artifact';

@Component({
  selector: 'app-activity-results',
  templateUrl: './activity-results.component.html',
  styleUrls: ['./activity-results.component.css']
})
export class ActivityResultsComponent extends BaseComponent implements OnChanges {

  @Input() activityResult: ActivityResult;
  @Input() studentID: number;

  getDescription = Encounter.getDescription;
  isInternalUser = this.authService.isInternal();

  ngOnChanges() {
  }

  getActivityDescription(): string
  {
    return this.activityResult.Description1 != this.activityResult.Description2 ? 
    this.activityResult.Description1 + ": " + this.activityResult.Description2: 
    this.activityResult.Description1;
  }

  getEncounters(skillType: string): Encounter[] {
    return this.activityResult.Encounters ? this.activityResult.Encounters.filter(e => e.SkillType.includes(skillType) && !e.SkillConcept.includes("_")) : [];
  }

  hasIncorrect(encounter: Encounter): boolean
  {
    return encounter.Attempts && encounter.Attempts.some(a => a.Result == 0);
  }

  hasAnyIncorrectEncounters(): boolean
  {
    return this.activityResult.InteractionCode != "CycleTest" && this.activityResult.Encounters && this.activityResult.Encounters.some(e => e.Attempts && e.Attempts.some(a => a.Result == 0));
  }

  questionTypeHasIncorrect(skillType: string): boolean
  {
    var filteredEncounters = this.activityResult.Encounters ? this.activityResult.Encounters.filter(e => e.SkillType.includes(skillType)) : null;
    return filteredEncounters && filteredEncounters.some(e => e.Attempts && e.Attempts.some(a => a.Result == 0));
  }

  // getResults(encounter: Encounter): string
  // {
  //   return encounter.Attempts.filter(a => a.Result == 1).length + "/" + encounter.Attempts.length;
  // }

  getPostDescription(): string {
    let isTest = this.activityResult.InteractionCode == 'UnitTest' || this.activityResult.InteractionCode == 'CycleTest';
    if (!isTest || !this.activityResult.Encounters) {
      return "";
    }

    var totalAttempts = this.activityResult.Encounters
      .filter(e => e.Attempts)
      .map(e => e.Attempts.length)
      .reduce((a,b) => a+b, 0);
    var successfulAttempts = this.activityResult.Encounters
      .filter(e => e.Attempts)
      .map(e => e.Attempts.filter(a => a.Result != 0).length)
      .reduce((a,b) => a+b, 0);

    var percent = Math.round((successfulAttempts / totalAttempts) * 100);

    return ` Score ${percent}%`;
  }

  getArtifacts(artifactType: string): GeneratedArtifactMeta[] {
    return this.activityResult.GeneratedArtifacts ? this.activityResult.GeneratedArtifacts.filter(a => a.ArtifactType === artifactType) : [];
  }
}